import Task from "../task";
import {toMomentDate} from "../../../gd/convert/moment-date";
import {calculateDisplayDates} from "../functions/display-dates";


export default function taskUpdateStartEndDate(task:Task, startDate:Moment|null, endDate:Moment|null) {

    if (!startDate) {
        task.startDate = null
        task.endDate   = null
        return
    }

    // if endDate BEFORE start set start = end because we update START here
    if (!endDate || endDate.isBefore(startDate,'days')) {
        endDate = toMomentDate(startDate)
    }

    task.startDate = toMomentDate(startDate)
    task.endDate   = toMomentDate(endDate)

    // schedule
    task.autoUpdateScheduleDate()

}